import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ValidationService } from '../../shared/providers/validation.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { PropertyStatus } from '../../shared/enum/enum';
import { ToastService } from '../../shared/providers/toast.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IChangePropertyStatus } from '../../shared/models/ChangePropertyStatusInputModel';
import { BrokerageManagerService } from '../../shared/providers/brokerage-manager.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { collapseColumns } from '../../shared/models/collapseColumns';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { CommonService } from '../../shared/providers/common.service';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';

enum Tab {
  DataEntry = 1,
  Salesforce = 2,
  NewProperty = 3,
  Duplicates = 4
}

export interface IApprovalList {
  PropertyId: number;
  PropertyGuid: string;
  TenantName: string;
  GuarantorName: string;
  Tenant: string;
  TenantId?: number;
  State: string;
  City: string;
  Address: string;
  PropertyStatus: string;
  PropertyType: string;
  Brokerage: string;
  SourceURL: string;
  AskingPrice: number;
  CapRate?: number;
  UpdateDetails: string;
  LastModifiedBy: string;
  LastModifiedDate: Date;
  IsSelected: boolean | false;
  AuditTrailId: number;
  HasDuplicate: number;
  IsPortfolio?: boolean;
  PortfolioProperties?: any[]
  ShowPortfolioProperties?: boolean;
  OMFilePath: string;
  CharacteristicsId: number;
  capRateText: string;
  Unpriced: boolean;
}

export enum Actions {
  NothingSelected = 0,
  Approve = 1,
  Reject = 2,
  ApproveTenant = 3
}

export interface IBrokerage {
  Id: number;
  BrokerageName: string;
}

interface IFilters {
  BrokerageId: number;
  SearchText: string;
}

@Component({
  selector: 'app-property-approval-list',
  templateUrl: './property-approval-list.component.html'
})
export class PropertyApprovalListComponent implements OnInit {

  constructor(private http: HttpClient, public Validation: ValidationService, private _propertyListingService: PropertyListingService, private _toast: ToastService, private Loader: LoaderService, private modalService: BsModalService, private _brokerageManagerService: BrokerageManagerService, private activatedRoute: ActivatedRoute, private authService: AuthenticationService, public commonService: CommonService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['brokerage']) {
        this.selectedBrokerage = parseInt(params['brokerage']);
      }
      else if (params['TenantId']) {
        this.selectedTenantName = params['TenantName'];
        this.selectedTenantId = parseInt(params['TenantId']);
        this.addressType = 4;
        this.address = this.selectedTenantName;
      }
    });
  }

  tab = Tab;
  activeTab = Tab.DataEntry;
  activeSubTab = Tab.NewProperty;

  dtOptions = {};
  approvalList: IApprovalList[];
  selectedRows: IApprovalList[] = [];
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  selectedAction = 0;
  propertyStatus = PropertyStatus;
  changePropertyStatus = {} as IChangePropertyStatus;
  brokerageList: IBrokerage[];
  selectedBrokerage = 0;
  selectedTenantName = null;
  selectedTenantId = null;
  isDataEntryProperty: boolean = true;
  rowCount = 0;
  rowCountSalesforce = 0;
  addressType = 0;
  address = "";
  selectedPropertyId: string;
  quickEditDetails = [];
  filters = {} as IFilters;
  user: any;
  searchParameters = {} as IPropertySearchCriteria;
  IsLoading = false;
  ngOnInit() {
    this.user = this.authService.user;
    this.BindColumns();
    this._brokerageManagerService.getBrokerageList().subscribe(response => {
      this.brokerageList = response;
    });
    this.reassignFilters();
    this.reassignSelectedRows();
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      "pageLength": 50,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[14, "desc"]],
      bLengthChange: false,
      stateSave: true,
      stateSaveCallback: function (settings, data) {
        localStorage.setItem("DataTables_pending_approval_list", JSON.stringify(data));
      },
      stateLoadCallback: function (settings) {
        $(".dataTables_paginate.paging_full_numbers").show();
        return JSON.parse(localStorage.getItem("DataTables_pending_approval_list"));
      },
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          BrokerageId: that.selectedBrokerage,
          AddressType: this.addressType,
          Address: this.address,
          Type: this.activeTab == Tab.DataEntry ? 0 : 1
        }
        dataTablesParameters.Extra_param = filter;
        if (this.addressType == 4) {
          const search =
          {
            Value: that.selectedTenantName,
          }
          dataTablesParameters.Search = search;
          this.searchText = this.selectedTenantName;
        }
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/propertyApprovalList',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.approvalList = resp.data ? resp.data : [];

            that.approvalList.forEach(item => {
              if (this.selectedRows.findIndex(x => x.PropertyId == item.PropertyId) > -1) {
                item.IsSelected = true;
              }
              if (item.CharacteristicsId) {
                item.capRateText = 'ZCF';
              }
              else {
                item.capRateText = String(item.CapRate);
              }
            });

            this.selectAll = false;
            this.autoSelectAll();

            this.rowCount = resp.recordsTotal;
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: [{ data: 'Tenant' },
      { data: 'Tenant' },
      { data: 'PropertySequenceId' },

      { data: 'Tenant' },
      { data: 'State' },
      { data: 'City' },
      { data: 'TenantName' },
      { data: 'GuarantorName' },
      { data: 'PropertyType' },
      { data: 'PropertyStatus' },
      { data: 'Brokerage' },
      { data: 'OMFilePath' },
      { data: 'SourceURL' },
      { data: 'AskingPrice' },
      { data: 'CapRate' },
      { data: 'UpdateDetails' },
      { data: 'LastModifiedDate' }
      ]
    };
  }

  onSearch(text: string) {
    this.filters.SearchText = text;
    this.addressType = 0;
    this.preserveFilter();
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  openModalForQuickEdit(template: TemplateRef<any>, classes: any, id, state, city, brokerage) {
    this.quickEditDetails = [];
    this.modalRef = this.modalService.show(template, { class: classes });
    this.selectedPropertyId = id;
    this.quickEditDetails.push(state, city, brokerage);
  }

  selectedPropertyIdForDuplicates = 0;
  openModalForDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.selectedPropertyIdForDuplicates = id;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  closeModal($event) {
    this.modalRef.hide();
    this.dtElement.dtInstance.then(x => x.draw());
  }

  statusToChange = PropertyStatus.Available;
  modalRefApprove: BsModalRef;
  selectedPropId: number;
  selctedAction = Actions.Approve
  actions = Actions;
  isBulkAction = false;
  approveContent = "";
  selectedProperty = "";
  isPortfolio = false;
  openModal(event, template: TemplateRef<any>, propId: number, classes: string, action: number) {
    this.isBulkAction = false;
    this.selectedPropId = propId;
    let property = this.approvalList.find(x => x.PropertyId == propId);
    this.changePropertyStatus.PropertyIds = [];
    this.changePropertyStatus.Comments = null;
    this.selectedProperty = (property.Tenant != null ? property.Tenant : property.TenantName) + (property.State ? "," + property.State : "") + (property.City ? "," + property.City : "");
    this.selctedAction = action;
    this.isPortfolio = property.IsPortfolio;
    this.modalRefApprove = this.modalService.show(template, { class: classes });
  }
  Comments = "";
  changeStatus() {
    this.Loader.display(true);
    this.changePropertyStatus.PropertyIds = [];
    if (this.isBulkAction) {
      this.selectedRows.forEach(item => {
        this.changePropertyStatus.PropertyIds.push(item.PropertyId);
      });

      if (this.selectedBulkAction == Actions.Approve) {
        this.changePropertyStatus.Status = this.propertyStatus.Available;
        this.changePropertyStatus.Comments = null;
      }
      else if (this.selectedBulkAction == Actions.Reject) {
        this.changePropertyStatus.Status = this.propertyStatus.Rejected;
        this.changePropertyStatus.Comments = this.Comments;
      }
    }
    else {
      this.changePropertyStatus.PropertyIds.push(this.selectedPropId);
      if (this.selctedAction == Actions.Approve) {
        this.changePropertyStatus.Status = this.propertyStatus.Available;
        this.changePropertyStatus.Comments = null;
      }
      else if (this.selctedAction == Actions.Reject) {
        this.changePropertyStatus.Status = this.propertyStatus.Rejected;
        this.changePropertyStatus.Comments = this.Comments;
      }
    }

    this.changePropertyStatus.UserId = this.user.Id;

    this._propertyListingService.BulkStatusChangeWithComments(this.changePropertyStatus).subscribe(response => {
      if (response) {
        let currentPageSelectionCount = this.approvalList.filter(x => x.IsSelected == true).length;
        if (currentPageSelectionCount == this.approvalList.length) {
          this.dtElement.dtInstance.then(x => x.draw());
        }
        else {
          this.dtElement.dtInstance.then(x => x.draw(false));
        }

        this._toast.addToast({ title: 'Success', msg: 'Status changed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.resetSelectedRows();
        this.modalRefApprove.hide();
      }
      else {
        this._toast.addToast({ title: 'Error Occurred', msg: 'Failed to change status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.modalRefApprove.hide();
      }
      this.Loader.display(false);
    });
  }

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }
  selectAll = false;
  selectOrUnSelectAll(trueOrfalse) {
    this.approvalList.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex(x => x.PropertyId == item.PropertyId) < 0) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.PropertyId == item.PropertyId), 1);
      }
    });

    this.preserveSelectedRows();
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  preserveSelectedRows() {
    localStorage.setItem("pending_approval_list_selectedRows", JSON.stringify(this.selectedRows));
  }

  onCheckboxChange(event, propertyid) {
    if (event.target.checked) {
      let prop = this.approvalList.find(x => x.PropertyId == propertyid);
      this.selectedRows.push(prop);
    }
    else {
      this.selectedRows.splice(this.selectedRows.findIndex(x => x.PropertyId == propertyid), 1);
    }
    this.preserveSelectedRows();
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.approvalList.filter(x => x.IsSelected == true).length == this.approvalList.length && this.approvalList.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  reassignSelectedRows() {
    if (this.selectedRows.length == 0 && localStorage.getItem("pending_approval_list_selectedRows") !== null) {
      this.selectedRows = JSON.parse(localStorage.getItem("pending_approval_list_selectedRows"));
    }
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.approvalList) {
      this.approvalList.forEach(item => {
        item.IsSelected = false;
      });
    }
    this.selectAll = false;
    this.preserveSelectedRows();
  }

  //@ViewChild('Approve') Approve: TemplateRef<any>;
  //@ViewChild('Reject') Reject: TemplateRef<any>;

  selectedBulkAction = Actions.NothingSelected;
  onActionSelect(event, Approve, Reject) {
    this.isBulkAction = true;
    var istenantApprovalNeeded = this.selectedRows.filter(i => (!i.IsPortfolio && i.TenantId == null));
    if (this.selectedRows.length == 0) {
      this._toast.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      this.approveContent = this.selectedRows.length.toString();
      if (this.selectedBulkAction == Actions.Approve) {
        this.modalRefApprove = this.modalService.show(Approve, { class: 'deletemodal' });
      }
      else if (this.selectedBulkAction == Actions.Reject) {
        this.modalRefApprove = this.modalService.show(Reject, { class: 'panlestyle' });
      }
    }
    event.target.value = 0;
  }

  onActionBrokerageSelect(event) {
    this.filters.BrokerageId = this.selectedBrokerage;
    this.preserveFilter();
    this.dtElement.dtInstance.then(x => x.draw(false));
  }

  AuditId: number;
  modalRef: BsModalRef;
  openModalForAuditTrailDetail(template: TemplateRef<any>, classes: any, id) {
    this.AuditId = id;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  preserveFilter() {
    localStorage.setItem("pending_approval_list_filter", JSON.stringify(this.filters));
  }
  searchText = "";
  reassignFilters() {
    if (localStorage.getItem("pending_approval_list_filter") !== null) {
      this.filters = JSON.parse(localStorage.getItem("pending_approval_list_filter"));

      if (!this.Validation.IsinValid(this.filters.BrokerageId)) {
        this.selectedBrokerage = this.filters.BrokerageId;
      }

      if (!this.Validation.IsinValid(this.filters.SearchText)) {
        this.searchText = this.filters.SearchText;
      }
    }
  }

  selectedColumns = [];
  //defaultTypeText: IMultiSelectTexts = {
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  }

  hideColumn(col: number) {
    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    }
    else {
      return true; // hide
    }
  }
  tableColumns: collapseColumns[] = [];
  BindColumns() {
    this.tableColumns = [
      { id: 1, name: 'State' },
      { id: 2, name: 'City' },
      { id: 3, name: 'Property Type' },
      { id: 4, name: 'Property Status' },
      { id: 5, name: 'Brokerage' },
      { id: 6, name: 'Source URL' },
      { id: 7, name: 'Asking Price' },
      { id: 8, name: 'CAP Rate' },
      { id: 9, name: 'Update' },
      { id: 10, name: 'Last Modified' },
    ]
    this.selectedColumns = [];
    if (localStorage.getItem("pending_approval_list_selectedColumns_LS") !== null) {
      this.selectedColumns = JSON.parse(localStorage.getItem("pending_approval_list_selectedColumns_LS"));
    }
    else {
      this.tableColumns.forEach(item => {
        this.selectedColumns.push(item.id);
      });
    }
  }

  onRedirection() {
    localStorage.setItem("pending_approval_list_selectedColumns_LS", JSON.stringify(this.selectedColumns));
  }

  showPortfolioProperties(id, index) {
    let that = this;
    this.searchParameters.PropertyId = id;
    if (this.approvalList[index].PortfolioProperties == undefined || this.approvalList[index].PortfolioProperties.length == 0) {
      this.Loader.display(true);
      this._propertyListingService.GetDataentryPortfolioPropertiesList(this.searchParameters).subscribe(item => {

        that.approvalList[index].PortfolioProperties = [];
        that.approvalList[index].PortfolioProperties = item;
        that.approvalList[index].PortfolioProperties.forEach(item => {
          if (item.CharacteristicsId) {
            item.capRateText = 'ZCF';
          }
          else {
            item.capRateText = String(item.CapRate);
          }
        });
        //this.propertyList[index].PortfolioProperties.forEach(item => {
        //    item.Remaining_Term = this._valdateService.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate);
        //});
        that.approvalList[index].ShowPortfolioProperties = true;
        that.Loader.display(false);
      })
    }
    else {
      this.approvalList[index].ShowPortfolioProperties = !this.approvalList[index].ShowPortfolioProperties;
    }
  }

  onTabClick(selectedTab) {
    this.activeTab = selectedTab;
    this.activeSubTab = this.tab.NewProperty;
    //this.searchText = '';
    this.rowCount = 0;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  onSubTabClick(selectedTab) {
    this.activeSubTab = selectedTab;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  addTenantGuarantor() {
    this.Loader.display(true);
    var that = this;
    this._propertyListingService.ApproveTenantAndGuarantor(this.selectedPropId).subscribe(item => {

      this.modalRefApprove.hide();
      this.dtElement.dtInstance.then(x => x.draw());
      that.Loader.display(false);
    });
  }
}

